import { cn } from '@/lib/utils';
import { PublicCostLineDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';
import { formatPrice } from '@/utils/formatters.ts';

interface BillLineRowProps extends React.HTMLAttributes<HTMLDivElement> {
  line: PublicCostLineDto;
}

/**
 * Wiersz rachunku: co, które i za ile.
 *
 * `value` mają tylko pozycje wybierane z katalogu — przy cenie podstawowej, zniżce i pozycji ręcznej
 * etykieta mówi wszystko i druga kolumna byłaby pusta.
 */
const BillLineRow = ({ line, className, ...props }: BillLineRowProps) => (
  <div
    className={cn('flex items-baseline gap-x-3 py-1.5 text-[15px]', className)}
    {...props}
  >
    {/* Kwota nie schodzi do drugiej linii: zawija się opis, bo to on bywa długi. */}
    <span className="flex min-w-0 flex-wrap items-baseline gap-x-2.5">
      <span className="text-neutral-600">{line.label}</span>
      {line.value && (
        <span className="wrap-anywhere font-medium text-ink">{line.value}</span>
      )}
    </span>
    <span className="ml-auto shrink-0 font-semibold tabular-nums text-ink">
      {formatPrice(line.amount.amount, line.amount.currency)}
    </span>
  </div>
);

export default BillLineRow;
